import React, { Component } from 'react';
import { connect } from 'react-redux';
import Content from './Content';
import { withRouter } from 'react-router-dom';
import { convertPoseStringIntoArray, convertPoseArrayIntoString } from './helper';

const ContentManager = ({ poseLookupString, location, history, dispatch }) => {

    const paramString = "A-B-C+D-E-F+G+I-J+K-L-PP+G2+I2-J2+N-M-PP+O+P-Q-R+S-T+U-V-PP+O2+P2-Q2-R2+S2-T2+W-V2-PP+X+Y-Z-AA+BB-CC+DD-EE-PP+X2+Y2-Z2-AA2+BB2-CC2+FF-EE2-GG-OO+HH-JJ-JJ2+LL-MM-NN-MM2-NN2-QQ" //(!poseLookupString || poseLookupString === "") ? location.search.replace("?", "") : poseLookupString;

    //dispatch({type:'SET_POSELOOKUPSTRING_FROM_PARAM', poseLookupString:paramString})

    if (poseLookupString) {
      history.replace({search: '?' + poseLookupString})
    }

    const poseLookup = convertPoseStringIntoArray(paramString)

    return <Content poseLookup={poseLookup}/>

}

const mapStateToProps = (state) => ({
  poseLookupString: state.poseLookupString,
});

export default connect(mapStateToProps)(withRouter(ContentManager));



// WEBPACK FOOTER //
// ./src/ContentManager.js